import { IAppReducer } from 'models/reducer.interface';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

interface ISubscriptionsGuardProps {
  children: JSX.Element;
}

/**
 * Cuando Soda impersona a un usuario con su propio panel de suscripciones ya
 * habilitado (`agentAuthData.subscriptionsEnabled`), esa vista pasa a ser la
 * autoritativa: se saca al agente de la lista vieja de Meraki y se lo regresa
 * a Soda (`returnUrl`). No cierra la sesión de Firebase — el agente puede
 * seguir usando otras páginas de Meraki durante la misma impersonation
 * (ej. add-subscription).
 */
export const SubscriptionsGuard = ({ children }: ISubscriptionsGuardProps) => {
  const { agentAuthData } = useSelector((state: IAppReducer) => state.authReducer);
  const returnUrl = agentAuthData?.returnUrl;
  const shouldRedirect = Boolean(agentAuthData?.subscriptionsEnabled && returnUrl);

  useEffect(() => {
    if (!shouldRedirect || !returnUrl) return;
    globalThis.location.href = returnUrl;
  }, [shouldRedirect, returnUrl]);

  if (shouldRedirect) {
    return null;
  }

  return children;
};
